/* eslint-disable react/no-unknown-property */
/* eslint-disable no-useless-escape */
/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../Components/Header";
import SubHeader from "../Components/SubHeader";
import Loader from "../Components/Loader";
import Footer from "../Components/Footer";
import UniversalVideoPlayer from "../Components/YoutubePlayer";
import Cookies from "js-cookie";
import ApiService from "../Services/ApiService";

import "../Styles/ofislerimiz.css";
import {
  MapPin,
  Calendar,
  Navigation,
  Star,
  ChevronRight,
  Video,
  X,
  ChevronLeft,
} from "lucide-react";

// Swiper componentleri
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Scrollbar, Navigation as SwiperNavigation } from "swiper/modules";

// Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/scrollbar";
import "swiper/css/navigation";

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let navigate = useNavigate();
    let params = useParams();
    return <Component {...props} router={{ navigate, params }} />;
  }

  return ComponentWithRouterProp;
}

class Ofislerimiz extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOffice: null,
      selectedVideo: null,
      offices: [],
      loading: true,
      error: null,
      isPreviewOpen: false,
      previewImages: [],
      currentPreviewIndex: 0,
    };
  }

  componentDidMount() {
    this.fetchOffices();
  }

  formatImageUrl = (url) => {
    if (!url) return "";
    if (url.startsWith("http")) return url;
    const baseUrl = ApiService.baseUrl || "https://nmuniversalteam.com";
    return `${baseUrl}${url}`;
  };

  fetchOffices = async () => {
    try {
      const data = await ApiService.get("/api/ofisler/public/offices");
      
      if (!Array.isArray(data)) {
        throw new Error("Ofisler yüklenemedi veya geçersiz yanıt alındı.");
      }

      this.setState({ offices: data, loading: false }, () => {
        // Parametreleri kontrol et
        const { slug, videoId } = this.props.router.params;
        if (slug) {
          const office = this.state.offices.find((o) => o.slug === slug);
          if (office) {
            this.setState({ selectedOffice: office });

            if (videoId && office.videos) {
              const video = office.videos.find((v) => v.id.toString() === videoId);
              if (video) {
                this.setState({ selectedVideo: video });
              }
            }
          }
        }
      });
    } catch (error) {
      console.error("Ofis verileri çekilirken hata oluştu:", error);
      this.setState({ loading: false, error: "Ofisler yüklenemedi." });
    }
  };



  componentDidUpdate(prevProps) {
    const { slug, videoId } = this.props.router.params;
    const prevSlug = prevProps.router.params.slug;
    const prevVideoId = prevProps.router.params.videoId;

    if (slug !== prevSlug || videoId !== prevVideoId) {
      if (slug) {
        const office = this.state.offices.find((o) => o.slug === slug);
        if (office) {
          this.setState({ selectedOffice: office });

          if (videoId && office.videos) {
            const video = office.videos.find(
              (v) => v.id.toString() === videoId
            );
            if (video) {
              this.setState({ selectedVideo: video });
            } else {
              this.setState({ selectedVideo: null });
            }
          } else {
            this.setState({ selectedVideo: null });
          }
        } else {
          this.props.router.navigate("/ofislerimiz");
        }
      } else {
        this.setState({ selectedOffice: null, selectedVideo: null });
      }
    }
  }

  handleImageError = (e) => {
    e.target.src = this.getGrayFallback();
  };

  getLoomId = (url) => {
    const loomRegExp = /(?:loom\.com\/share\/)([^#&?]*)/;
    const match = url.match(loomRegExp);
    return match ? match[1] : "";
  };

  getYouTubeId = (url) => {
    const youtubeRegExp =
      /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/;
    const match = url.match(youtubeRegExp);
    return match ? match[1] : "";
  };

  getVideoPlatform = (url) => {
    if (!url) return "unknown";
    if (url.includes("loom.com")) return "loom";
    if (url.includes("youtube.com") || url.includes("youtu.be"))
      return "youtube";
    if (url.match(/\.(mp4|webm|ogg|mov|m4v)(?:\?.*)?$/i) ||
      url.includes('storage.googleapis.com') ||
      url.includes('/uploads/ofisler/'))
      return "direct";
    return "unknown";
  };

  getGrayFallback = () => {
    return "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIwIiBoZWlnaHQ9IjE4MCIgdmlld0JveD0iMCAwIDMyMCAxODAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIzMjAiIGhlaWdodD0iMTgwIiBmaWxsPSIjZjBmMGYwIi8+CjxjaXJjbGUgY3g9IjE2MCIgY3k9IjkwIiByPSIyNCIgZmlsbD0iI2NjY2NjYyIvPgo8cGF0aCBkPSJtMTUyIDgyIDEyIDggLTEyIDh2LTE2eiIgZmlsbD0iI2ZmZmZmZiIvPgo8L3N2Zz4=";
  };

  handleThumbnailError = (e, video) => {
    const platform = this.getVideoPlatform(video.url);
    const currentSrc = e.target.src;

    if (platform === "loom") {
      const videoId = this.getLoomId(video.url);

      if (currentSrc.includes("-00001.jpg")) {
        e.target.src = `https://cdn.loom.com/sessions/thumbnails/${videoId}.jpg`;
      } else if (currentSrc.includes(".jpg") && !currentSrc.includes("-")) {
        e.target.src = `https://cdn.loom.com/sessions/thumbnails/${videoId}-preview.jpg`;
      } else {
        e.target.src = this.getGrayFallback();
      }
    } else if (platform === "youtube") {
      const videoId = this.getYouTubeId(video.url);

      if (currentSrc.includes("maxresdefault.jpg")) {
        e.target.src = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
      } else if (currentSrc.includes("hqdefault.jpg")) {
        e.target.src = `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`;
      } else {
        e.target.src = this.getGrayFallback();
      }
    } else {
      e.target.src = this.getGrayFallback();
    }
  };

  generateThumbnailUrl = (video) => {
    const platform = this.getVideoPlatform(video.url);

    if (platform === "loom") {
      const videoId = this.getLoomId(video.url);
      return `https://cdn.loom.com/sessions/thumbnails/${videoId}-00001.jpg`;
    } else if (platform === "youtube") {
      const videoId = this.getYouTubeId(video.url);
      return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
    } else if (platform === "direct") {
      // Direct video has no automatic thumb service, we use the video itself (browser will show first frame)
      return video.url;
    }

    return this.getGrayFallback();
  };

  handleVideoSelect = (video) => {
    this.setState({ selectedVideo: video });
    const { selectedOffice } = this.state;
    if (selectedOffice) {
      this.props.router.navigate(
        `/ofislerimiz/${selectedOffice.slug}/video/${video.id}`
      );
    }
  };

  handleBackFromVideo = () => {
    const { selectedOffice } = this.state;
    this.setState({ selectedVideo: null });
    if (selectedOffice) {
      this.props.router.navigate(`/ofislerimiz/${selectedOffice.slug}`);
    }
  };

  handleBackToOffices = () => {
    this.setState({ selectedVideo: null, selectedOffice: null });
    this.props.router.navigate("/ofislerimiz");
  };

  handleOfficeSelect = (office) => {
    this.props.router.navigate(`/ofislerimiz/${office.slug}`);
    this.setState({ selectedOffice: office });
  };

  openPreview = (images, index = 0) => {
    this.setState({
      isPreviewOpen: true,
      previewImages: images,
      currentPreviewIndex: index,
    });
  };

  closePreview = () => {
    this.setState({ isPreviewOpen: false });
  };

  nextPreview = (e) => {
    e.stopPropagation();
    const { currentPreviewIndex, previewImages } = this.state;
    this.setState({
      currentPreviewIndex: (currentPreviewIndex + 1) % previewImages.length,
    });
  };

  prevPreview = (e) => {
    e.stopPropagation();
    const { currentPreviewIndex, previewImages } = this.state;
    this.setState({
      currentPreviewIndex:
        (currentPreviewIndex - 1 + previewImages.length) % previewImages.length,
    });
  };

  handleBackToOfficeList = () => {
    this.setState({ selectedOffice: null });
    this.props.router.navigate("/ofislerimiz");
  };

  renderOfficeDetail = () => {
    const { selectedOffice } = this.state;

    return (
      <div className="office-detail-container">
        <div className="office-detail-header">
          <div className="office-detail-header-pattern" />

          <div className="container office-detail-header-container">
            <div className="row">
              <div className="col-lg-12">
                <button
                  onClick={this.handleBackToOfficeList}
                  className="back-button"
                >
                  ← Ofislere Dön
                </button>

                <div className="office-detail-header-content">
                  <div className="office-detail-title-container">
                    <h1 className="office-detail-title">
                      {selectedOffice.name}
                    </h1>
                  </div>

                  <div className="office-detail-meta">
                    <div className="office-detail-meta-item">
                      <MapPin size={16} />
                      {selectedOffice.location}
                    </div>
                    {selectedOffice.openDate && (
                      <div className="office-detail-meta-item">
                        <Calendar size={16} />
                        {selectedOffice.openDate}
                      </div>
                    )}
                  </div>

                  <p className="office-detail-description">
                    {selectedOffice.description}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="office-image-container">
          <div
            className="office-image-wrapper"
            onClick={() => this.openPreview([selectedOffice.image], 0)}
            style={{ cursor: "pointer" }}
          >
            <img
              src={this.formatImageUrl(selectedOffice.image)}
              alt={selectedOffice.name}
              className="office-main-image"
              onError={this.handleImageError}
            />
          </div>
        </div>

        <div className="office-detail-content">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                {selectedOffice.address && (
                  <div className="office-info-card universal-card universal-shimmer">
                    <div className="office-info-card-pattern universal-pattern" />

                    <div className="office-info-card-content">
                      <h3 className="office-info-card-title">
                        📍 Adres Bilgileri
                      </h3>

                      <p className="office-info-card-text">
                        {selectedOffice.address}
                      </p>
                    </div>
                  </div>
                )}

                {selectedOffice.alertTitle && selectedOffice.alertDescription && (
                  <div className="office-warning-card universal-card universal-shimmer">
                    <div className="office-warning-card-pattern universal-pattern" />

                    <div className="office-warning-card-content">
                      <h4 className="office-warning-title">{selectedOffice.alertTitle}</h4>
                      <p className="office-warning-text">
                        {selectedOffice.alertDescription}
                      </p>
                    </div>
                  </div>
                )}

                {selectedOffice.otherImages && selectedOffice.otherImages.length > 0 && (
                  <div className="office-gallery-card universal-card universal-shimmer">
                    <div className="office-gallery-card-pattern universal-pattern" />
                    <div className="office-gallery-card-content">
                      <h3 className="office-gallery-title">📷 Resimler</h3>
                      <Swiper
                        modules={[FreeMode, Scrollbar, SwiperNavigation]}
                        spaceBetween={15}
                        slidesPerView={"auto"}
                        freeMode={true}
                        scrollbar={{ draggable: true }}
                        navigation={true}
                        className="office-gallery-swiper"
                      >
                        {selectedOffice.otherImages.map((img, index) => (
                          <SwiperSlide key={index} className="gallery-slide">
                            <div
                              className="gallery-item"
                              onClick={() => this.openPreview(selectedOffice.otherImages, index)}
                            >
                              <img
                                src={this.formatImageUrl(img)}
                                alt={`${selectedOffice.name} ${index + 1}`}
                                onError={this.handleImageError}
                              />
                            </div>
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    </div>
                  </div>
                )}

                {selectedOffice.videos && selectedOffice.videos.length > 0 && (
                  <div className="office-videos-card universal-card universal-shimmer">
                    <div className="office-videos-card-pattern universal-pattern" />

                    <div className="office-videos-card-content">
                      <h3 className="office-videos-title">🎥 Videolar</h3>

                      <div className="row">
                        {selectedOffice.videos.map((video) => (
                          <div key={video.id} className="col-md-6 mb-20">
                            <div
                              onClick={() => this.handleVideoSelect(video)}
                              className="video-item universal-card universal-shimmer"
                            >
                              <div className="video-item-pattern universal-pattern" />

                              <div className="video-item-content">
                                <div className="video-thumbnail-container">
                                  {video.thumbnail ? (
                                    <img
                                      src={this.formatImageUrl(video.thumbnail)}
                                      alt={video.title}
                                      className="video-thumbnail"
                                      onError={this.handleImageError}
                                    />
                                  ) : (
                                    <img
                                      src={this.formatImageUrl(this.generateThumbnailUrl(video))}
                                      alt="Video thumbnail"
                                      className="video-thumbnail"
                                      onError={(e) =>
                                        this.handleThumbnailError(e, video)
                                      }
                                    />
                                  )}
                                </div>

                                <h5
                                  className="video-title"
                                  style={{ padding: "10px 10px" }}
                                >
                                  {video.title}
                                </h5>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div className="col-lg-4">
                <div className="quick-actions-card universal-card universal-shimmer">
                  <div className="quick-actions-card-pattern universal-pattern" />

                  <div className="quick-actions-card-content">
                    <h4 className="quick-actions-title">🚀 Hızlı İşlemler</h4>

                    <div className="quick-actions-buttons">
                      {selectedOffice.mapsUrl && selectedOffice.mapsUrl.trim() !== "" && selectedOffice.address && selectedOffice.address.trim() !== "" && (
                        <a
                          href={selectedOffice.mapsUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="maps-button universal-button"
                        >
                          <Navigation size={16} />
                          Haritada Gör
                        </a>
                      )}

                      {selectedOffice.videos &&
                        selectedOffice.videos.length > 0 &&
                        (!selectedOffice.mapsUrl || selectedOffice.mapsUrl.trim() === "" || !selectedOffice.address || selectedOffice.address.trim() === "") && (
                          <button
                            onClick={() =>
                              this.handleVideoSelect(selectedOffice.videos[0])
                            }
                            className="video-button universal-button"
                          >
                            <Video size={16} />
                            İlk Videoyu İzle
                          </button>
                        )}
                    </div>
                  </div>
                </div>

                <div className="office-stats-card universal-card universal-shimmer">
                  <div className="office-stats-card-pattern universal-pattern" />

                  <div className="office-stats-card-content">
                    <h4 className="office-stats-title">📊 Ofis Bilgileri</h4>

                    <div className="office-stats-list">
                      <div className="office-stat-item">
                        <div className="office-stat-label">Lokasyon</div>
                        <div className="office-stat-value">
                          {selectedOffice.location}
                        </div>
                      </div>

                      {selectedOffice.openDate && (
                        <div className="office-stat-item">
                          <div className="office-stat-label">Açılış Tarihi</div>
                          <div className="office-stat-value">
                            {selectedOffice.openDate}
                          </div>
                        </div>
                      )}

                      {selectedOffice.videos && (
                        <div className="office-stat-item">
                          <div className="office-stat-label">Video Sayısı</div>
                          <div className="office-stat-value">
                            {selectedOffice.videos.length} Video
                          </div>
                        </div>
                      )}

                      <div className="office-stat-item">
                        <div className="office-stat-label">Durum</div>
                        <div className="office-stat-badge">✅ Aktif</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderVideoPlayer = () => {
    const { selectedVideo } = this.state;

    return (
      <div className="video-player-container">
        <div className="video-header">
          <div className="video-header-pattern" />

          <div className="container video-header-container">
            <div className="row">
              <div className="col-lg-12">
                <button
                  onClick={this.handleBackFromVideo}
                  className="video-back-button"
                >
                  ← Geri Dön
                </button>

                <div className="video-header-content">
                  <h1 className="office-detail-title">{selectedVideo.title}</h1>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="video-player-wrapper">
          <UniversalVideoPlayer
            videoUrl={this.formatImageUrl(selectedVideo.url)}
            isIlanDetay={true}
          />
        </div>
      </div>
    );
  };

  renderPreview = () => {
    const { isPreviewOpen, previewImages, currentPreviewIndex } = this.state;
    if (!isPreviewOpen || !previewImages.length) return null;

    return (
      <div className="image-preview-overlay" onClick={this.closePreview}>
        <button className="preview-close-button" onClick={this.closePreview}>
          <X size={32} />
        </button>

        {previewImages.length > 1 && (
          <>
            <button className="preview-nav-button prev" onClick={this.prevPreview}>
              <ChevronLeft size={48} />
            </button>
            <button className="preview-nav-button next" onClick={this.nextPreview}>
              <ChevronRight size={48} />
            </button>
          </>
        )}

        <div className="preview-content" onClick={(e) => e.stopPropagation()}>
          <img src={this.formatImageUrl(previewImages[currentPreviewIndex])} alt="Full size preview" />
        </div>

        <div className="preview-counter">
          {currentPreviewIndex + 1} / {previewImages.length}
        </div>
      </div>
    );
  };

  render() {
    const { offices, selectedVideo, selectedOffice } = this.state;

    return (
      <>
        <Loader />
        <SubHeader />
        <Header
          isLoggedIn={Cookies.get("token") == null ? false : true}
          userName="Mehmet Özkan"
        />
        {selectedVideo ? (
          this.renderVideoPlayer()
        ) : selectedOffice ? (
          this.renderOfficeDetail()
        ) : (
          <div className="offices-container">
            <div className="offices-header">
              <div className="offices-header-pattern" />

              <div className="container offices-header-container">
                <div className="row">
                  <div className="text-center">
                    <h6 className="offices-header-subtitle">🏢 OFİSLERİMİZ</h6>
                    <h1 className="offices-header-title">Ofislerimiz</h1>
                    <p className="offices-header-description">
                      UT gücüyle birçok ilde açılan ofislerimizde eğitim ve
                      etkinliklere katılarak ekibinizi ve işinizi
                      büyütebilirsiniz.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="offices-grid">
              <div className="container">
                <div className="row">
                  {offices.map((office) => (
                    <div key={office.id} className="col-lg-6 col-md-12 mb-40">
                      <div className="office-card universal-card universal-shimmer">
                        <div className="office-card-pattern universal-pattern" />

                        <div
                          className="office-card-content"
                          onClick={() => this.handleOfficeSelect(office)}
                          style={{ cursor: "pointer" }}
                        >
                          <div className="office-image">
                            <img
                              src={this.formatImageUrl(office.image)}
                              alt={office.name}
                              onError={this.handleImageError}
                            />

                            {office.isHeadquarter && (
                              <div className="office-badge">
                                <Star size={12} fill="white" />
                                Merkez Ofis
                              </div>
                            )}

                            {office.videos && office.videos.length > 0 && (
                              <div className="office-video-badge">
                                <Video size={12} />
                                {office.videos.length} Video
                              </div>
                            )}
                          </div>

                          <div className="office-content">
                            <div className="office-content-inner">
                              <h4 className="office-title">{office.name}</h4>

                              <div className="office-location">
                                <MapPin
                                  size={14}
                                  className="office-location-icon"
                                />
                                {office.location}
                              </div>

                              {office.openDate && (
                                <div className="office-date">
                                  <Calendar
                                    size={14}
                                    className="office-date-icon"
                                  />
                                  {office.openDate}
                                </div>
                              )}

                              <p className="office-description">
                                {office.description}
                              </p>

                              {office.address && (
                                <div className="office-address-container">
                                  <div className="office-address-label">
                                    Adres:
                                  </div>
                                  <div className="office-address-text">
                                    {office.address}
                                  </div>
                                </div>
                              )}
                            </div>

                            <div className="office-actions">
                              <button
                                onClick={() => this.handleOfficeSelect(office)}
                                className="office-detail-button universal-button"
                              >
                                <ChevronRight size={14} />
                                Detay
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}

        <Footer />
        {this.renderPreview()}
      </>
    );
  }
}

export default withRouter(Ofislerimiz);
